import actions from "./actions";
import { default as OrdersReducer, sliceActions } from "./reducer";

export { default as OrdersSaga } from "./sagas";
export { default as OrderSelectors } from "./selectors";
export { default as OrderThunks } from "./thunks";

const OrderActions = { ...actions, ...sliceActions };
export { OrdersReducer, OrderActions };
